

export default {
  'en':
    {

      men: 'men',
      women: 'women',
      kids: 'kids',
      includes:"Includes",
      shirts: 'shirts',
      shoes: 'shoes',
      currency: 'EGP',
      Accessories: 'Accessories',
      Collections: 'Collections',
      OFFERS: 'OFFERS',
      Outfits: 'Outfits',
      Brands: 'Brands',
      Yours: 'YourTopCategories',
      Choose: 'Choose Between Different Categories',
      Jeans: 'Jeans',
      brands: 'Popular Brands',
      Shirts: 'Shirts',
      Shoes: 'Shoes',
      Perfumes: 'Perfumes',
      Shorts: 'Shorts',
      New: 'New',
      Show: 'Show',
      discover: 'discover',
      Arrivals: 'Arrivals',
      Collection: 'Collection',
      Lifestyle: 'Lifestyle',
      More: 'Discover More... ',
      Jeans: 'Jeans',
      afterRegister:"* After Registering, you will receive an email with a verification Code to verify your account.",      
      Brands: 'PopularBrands',
      fromcoll: 'From The Collection',
      Nike: 'Nike',
      More: 'Discover More...',
      Neww: 'New',
      Swoosh: 'Nike Dry Swoosh',
      Price: '700.00 EGP',
      Max: 'NIKE AIR MAX 2018',
      pricemax: '1500.00 EGP',
      noproductMsg:'There are no products available',
      Formal: 'For Formal Occasions',
      Outfit: ' New Outfit collection',
      occasion: 'Because you can choose between different outfits and styles for your occasion and also try to find the suitable size for you',
      Formal: 'For Formal Occasions',
      moore: ' Discover More...',
      Outfit: ' New Outfit collection',
      occasion: 'Because you can choose between different outfits and styles for your occasion and also try to find the suitable size for you',
      moore: ' Discover More...',
      Sale: ' Final Summer Sale',
      Extra: '50% EXTRA on everything on sale',
      Outfitss: 'Outfits',
      Discover: ' Discover More... ',
      wish: '200',
      namehere: 'Outfit Name Here',
      fsale: '2000.00 EGP',
      come: '1000.00 EGP',
      event: 'Event',
      egyfash: ' Egypt Fashion Festival 2018',
      date: '15th - 19th September 2018 ',
      poppro: 'Popular Products',
      saleext: ' 50% EXTRA on everything on sale',
      outfits: 'outfits',
      dismore: 'Discover More... ',
      wish: '200',
      fitname: 'Outfit Name Here ',
      priceprod: '1000.00 EGP',
      shipping: 'Shipping',
      billing:'Billing',
      updateError:'Update Error',
      shippingAndBillingInfo:'SHIPPING &BILLING INFO',
      fill:'Fill all the following forms with required data',
      orders: 'Orders over 1000 EGP',
      community:"Join Our Community",      
      return: '14 days return',
      proplem: 'If goods have problem',
      payment: 'Secure payment',
      secure: '100% secure payment',
      support: '24h Support',
      Dedicated: 'Dedicated Support ',
      Subscribe: 'Do not miss anything ! Subscribe',
      informed: 'I would like to be informed about current trends, offers and vouchers by e-mail in the future. A deregistration is possible at any time free of charge.',
      TShirts: 'T-Shirts',
      Shirts: 'Shirts',
      Shoes: 'Shoes',
      Accessorie: 'Accessories',
      newarr: 'New Arrival',
      popular: ' Popular Products',
      Trending: 'Trending Products',
      Tbrands: 'Trends Brands',
      Bestie: 'Best Sellers',
      duct: 'Product',
      catee: 'Categories',
      acc: ' My Account',
      prof: ' My Profile',
      order: 'My Orders',
      wishhy: 'My Wishlist',
      // paymentfot: 'My Payment',
      addr: 'Address',
      district: 'Nasr City , Egypt 9 Hafez Ramadan St. of Ahmed Fakhry St.  6th District',
      call: 'Call Us: (+2) 123-456-789',
      copyright: '@ 2018 Dollaby. - All Rights Reserved',
      wom: 'Women',
      sortby: 'Sort By : ',
      action: 'Action',
      antaction: 'Another action',
      elsehere: 'something else here',
      Separated: 'Separated link',
      elsehere: 'something else here',
      Separated: 'Separated link',
      itempage: 'Show : ',
      Filtercat: ' Filter Category',
      mencategory: 'Men Category',
      womencategory: 'Women Category',
      kidscategory: 'Kids Category',
      shopcategory: 'Shop Category',
      size: ' Size',
      smallsize: 'Small Sizes',
      medsize: 'Medium Sizes',
      ssize: 'Small Sizes',
      large: 'Large Sizes',
      pstyle: 'Product Style',
      clsstyle: 'Classic Styles',
      cagstyle: 'Casual Styles',
      bigstyle: 'Big Style',
      flatstyle: 'Flat Style',
      advstyle: 'Adventure Style',
      fet: ' Features',
      egy: 'Made In Egypt',
      ek: 'Made In Ek',
      brandss: 'Brands',
      search: 'Search For a Brand',
      calvin: 'Calvin Klien',
      zara: 'Zara',
      polo: 'Polo Ralph Lauren ',
      procolor: 'Product Colour',
      prored: 'Red',
      toprates: 'Top Rates',
      fife: '5 Stars',
      four: '4 Stars',
      three: '3 Stars',
      topproduct: ' Top Rating Products',
      shirtctn: 'Casual Shirt Cotton New 2018 Spring',
      priceee: '17800.00 L.E ',
      fpro: ' Featured Products',
      salee: 'Discount 29%',
      corporate: 'Corporate Formal Shirt Rs',
      rev: '(130 review)',
      was: '$122.00',
      new: '$122.00',
      cartt: 'Add to Cart',
      discount: 'Discount 29%',
      corporate: 'Corporate Formal Shirt Rs',
      rev: '(130 review)',
      was: '$122.00',
      new: '$122.00',
      lorem: ' Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam fringilla augue nec est tristique auctor. Donec non est at libero vulputate rutrum. Morbi ornare lectus quis justo gravida semper. Nulla tellus mi, vulputate adipiscing cursus eu, suscipit id nulla.',
      cartt: 'Add to Cart',
      vious: 'Previous',
      next: 'Next',
      log: 'Login',
      isRequired:'is required',
      problemOccurred:"Oops! A problem occured",
      loginReg:"Login/Register",
      logout:"Logout",
      get: 'Get in, and discover Our outfits',
      rem: 'Remember me',
      pass: ' Lost Your Password',
      agree: ' By login you agree to our',
      terms: 'terms & conditions',
      us: ' of use',
      community: ' Join Our Community',
      reg: ' Register',
      loreem: 'Lorem ipsum dolor sit amet, conse ctetur adipisicing elit, sed do eius mod tempor incididunt ut labore et dolore magna aliqua.',
      creat: ' Create an account',
      mail: 'Enter your email address',
      sign: 'SIGN UP',
      userinfo: ' User Information',
      shipadd: 'Shipping Address',
      order: 'Orders History',
      paymet: 'Payment Methods',
      revv: 'Reviews & Rating',
      basiinfo: ' Basic Information',
      clicuplod: 'Click to Upload',
      fulname: 'Name',
      emil: 'E-Mail',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      mahmod: 'Mahmoud Seif El Nasr',
      birth: 'Birthday',
      dateselec: 'Click to select a date',
      male: 'Male',
      country: 'Country :',
      state: 'State :',
      status:"Status",
      postal: 'Postal Code  :',
      phone: 'Phone',
      additionalPhone:'Additional Phone Number',
      same:'Billing to the same address',
      orderTotal:'Order Total',
      totalCost:'Total Cost',
      placeOrder:'Place Order',
      social: 'Social Information',
      availableColours: "Available Colours",
      awaitingDel:'Awaiting Delivery',
      // fb:'Facebook :',
      // twitt:'Twitter :',
      // yout:'Youtube :',
      // insta:'Instagram  :',
      upprof: 'Update Profile',
      home: 'Home',
      shopp: ' Shopping Cart',
      shopping:'Shopping',
      shippingAndPaymentInfo:'Shipping & Payment',
      confirmation:'Confirmation',
      prod: 'Product',
      price: ' Price',
      quantity: ' Quantity',
      totalpric: 'Total Price',
      action: 'Action',
      teeshirt: 'Tee shirt homme manches courtes encolure gr/m2 100% coton KARIBAN K357.',
      menshirts: 'Men - Shirts',
      blue: ' Blue',
      categ: ' Category :',
      colorr: 'Colour :',
      sizee: ' Size :',
      salary: '180 EGP',
      salary: '180 EGP',
      teeshirt: 'Tee shirt homme manches courtes encolure gr/m2 100% coton KARIBAN K357.',
      menshirts: 'Men - Shirts',
      blue: ' Blue',
      salary: '180 EGP',
      calcu: 'Calculate Shipping',
      someelse: 'Something else here',
      separated: 'Separated link',
      someelse: 'Something else here',
      separated: 'Separated link',
      city: 'City',
      country: 'Country',
      update: 'Update',
      coupon: ' Coupon Code',
      loreem: ' Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      codee: 'Add Code Here',
      app: '  Apply',
      sub: ' Cart Sub-Total :',
      cartt: ' Cart total :',
      salary: '1440 EGP ',
      handle: 'Shipping & Handling : ',
      free: 'FREE',
      salary: '1440 EGP ',
      total: ' Cart Total :',
      checkout: ' Proceed to Checkout ',
      itemtitle: 'item.title',
      method: ' Add Payment Method',
      cridt: ' Credit Card ',
      pypl: 'paypal',
      cash: 'Cash On Delivery',
      action: 'Action',
      anotaction: 'Another action',
      someelse: 'Something else here',
      separated: 'Separated link',
      conttwo: 'Tab 2 content',
      contthre: 'Tab 3 content',
      addpaymen: 'Add Payment Method',
      process: 'Cancel Process',
      exyear: 'Expire Year',
      exmonth: 'Expire Month',
      details:'Details',
      ecom: ' E-Commerce Terms and Conditions',
      loreem: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. <br /> <br />     Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.<br /> <br /> Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.',
      number: '  Numbered List',
      consectetur: ' Lorem ipsum dolor sit amet, consectetur',
      eiusmod: 'adipisicing elit, sed do eiusmod',
      tempor: 'tempor incididunt ut labore et dolore magna',
      mark: 'Markered List',
      table: 'Table',
      popitem: 'Popular Items',
      size: 'Size',
      color: 'Color',
      drinks: ' One, there are drinks that make you shrink',
      inche: '16 Inches',
      color: ' Black',
      grow: 'Two, there are foods that make you grow.',
      inche: '22 Inches',
      color: 'White',
      grow: 'Three, animals can talk.',
      inche: 'Mega Fridge',
      color: 'Red',
      grow: '   Four, cats can disappear.',
      inche: 'Small Fridge',
      bestSellingProd:'Best Selling Products',
      color: 'Green',
      text: ' Text &amp; Quote ',
      loreim: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco ',
      emone: 'laboris nisit ut aliquip ex',
      emtwo: 'ea commodo consequat. ',
      loreimm: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut .',
      loreim: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.     Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem ',
      emone: 'accusantium doloremque',
      emtwo: 'laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. ',
      itemtitle: 'item.title',
      availableSizes: "Availabe Sizes",
      productQuantity: "Product Quantity",
      nocolor: 'No Colors Available',
      addcart: 'Add to Cart',
      producttype: 'Product Type :',
      addshipping: ' Add Shipping Address Information',
      location: 'Location Map',
      firstname: 'First Name',
      lastname: 'Last Name',
      email: 'Email',
      addressOne: 'Address 1',
      addressTwo: 'Address 2',
      ipsum: 'Lorem ipsum ,',
      town: ' Town',
      mobile: 'Mobile',
      note: 'Notes',
      country: 'Country',
      addadress: 'Save',
      cancel: 'Cancel Process',
      emptyCart: "Your shopping cart is empty.",
      Search: "SEARCH",
      password: "Password",
      processing:'processing',
      retypePassword:"Retype Password",
      NewPassword:"New Password",
      errorOcc:'An error has occured',
      welcomeMsg:"Welcome to Dollaby",
      loginsuccess:"Login Success",
      AtoZ:"A to Z",
      ZtoA:"Z to A",
      LowtoHigh:"Price (low - high)",
      HightoLow:"Price (high - low)",
      noTypes:'No Types are available for this Category',
      dimensions:'dimensions',
      itempage1:' 12 Items Page',
      itempage2:' 24 Items Page',
      itempage3:' 48 Items Page',
      orderNumber:"Order Number",
      orderDate:"Order Date",
      orderDetails:"Your Order Details",
      subtotal:'Order Sub-Total:',
      customerDetails:'Customer Details',
      biladd:'Billing Address',
      backtoshopping:'Back To Shopping',
      reviewedOrder:'Will get reviewed and ship it as soon as possible',
      thankyou:'THANK YOU !',
      recieveMsg:"Your order has been received ",
      detailsMsg:'Your order Details ',
      print:'Print',
      forShipping:'for shipping',
      items:'Items',
      outDel:"Out for delivery",
      pendingApp:"Pending Approval",
      complete:"Complete",
      refunded:"Refunded",
      succOrderMsg:"Successfully added your order",
      succProfile:'Successfully updated your account',
      success:'Success',
      succUpdate:'Successful Update!',
      addWishMsg:'Successfully added item to your wishlist',
      noProdWish:'No products available in your wishlist',
      loginerror:'Login Error',
      incorrectCredentials:"Incorrect login credentials",
      passwordrequire:"Password is required",
      phonerequire:'Phone number is required',
      retypeMsg:'Please retype the password',
      matcherror:'Passwords do not match',
      phoneexists:'This phone number already exists',
      logincart:'You need to be logged in to add to cart',
      orderlimitmsg:'You cannot order more than 10 items of the same product',
      itemAddederror:'Item was not added to cart',
      cartsuccess:'Added to cart successfully',
      prodcartadded:'The product has been added to your cart',
      oldpassRequired:'Old Password is required',
      removeWishMsg:'Successfully removed item from your wishlist'







    },
  'ar':
    {
      men: 'رجل',
      women: 'أمراة',
      kids: 'اطفال',
      includes:'يتضمن',
      forShipping:'للشحن',
      shirts: 'تيشرت',
      shoes: 'احذية',
      currency: 'جنيه',
      noproductMsg:'لا توجد منتجات متاحة',
      Accessories: 'اكسسوارات',
      awaitingDel:'إنتظار التسليم',
      prodcartadded:'تمت إضافة المنتج إلى سلة التسوق الخاصة بك',
      outDel:"خارج للتوصيل",
      Collections: 'منتجات',
      addWishMsg:'تمت إضافة العنصر بنجاح إلى قائمة المفضلات',
      removeWishMsg:'تمت إزالة العنصر بنجاح من قائمة المفضلات',
      succProfile:'تم تحديث حسابك بنجاح',
      succUpdate:'تحديث ناجح!',
      oldpassRequired:"كلمة المرور القديمة مطلوبة",
      OFFERS: 'عروض',
      processing:'معاملة',
      status:"الحالة",
      welcomeMsg:'مرحبا بك في دولابي',
      passwordrequire:'كلمة المرور مطلوبة',
      phonerequire:'رقم الهاتف مطلوب',
      incorrectCredentials:"بيانات اعتماد تسجيل الدخول غير صحيحة",
      Outfits: 'ملابس',
      Brands: 'براندات',
      Yours: 'الاقسام الاكثر زيارة',
      Choose: 'اختر بين فئة من فئاتك',
      Jeans: 'جينز',
      itemAddederror:'لم تتم إضافة العنصر إلى عربة التسوق',
      cartsuccess:'تمت الإضافة إلى عربة بنجاح',
      updateError:'خطأ في التحديث',
      logincart:'يجب أن تكون مسجلاً لإضافة إلى سلة التسوق',
      orderlimitmsg:'لا يمكنك طلب أكثر من 10 عناصر من نفس المنتج',
      isRequired:'مطلوب',
      Shirts: 'قمصان',
      Shoes: 'احذية',
      Perfumes: 'عطور',
      Shorts: 'شورت',
      New: 'لوك جديد',
      succOrderMsg:'تم إضافة طلبك بنجاح',
      success:'نجاح',
      problemOccurred:'حدثت مشكلة',
      phoneexists:'رقم الهاتف هذا موجود بالفعل',
      errorOcc:"حدث خطأ",
      Show: 'عرض كوليكشن ملابس كلاسيكية جديدة',
      discover: '... اكتشف المزيد',
      Arrivals: 'الزائرون الجدد',
      Collection: 'عن جميع المنتجات',
      Lifestyle: 'لايف ستايل',
      More: 'أكتشف المزيد ',
      Jeans: 'جينز',
      brands: 'البراندات المشهور',
      fromcoll: 'عن البراندات',
      Nike: 'نايكي',
      More: 'اكتشف المزيد',
      Neww: 'الجديد',
      swoosh: 'ماركة نايكي سووش',
      pendingApp:"إنتظار الموافقة",
      price: '٧۰۰,۰۰ جنيه',
      loginsuccess:"النجاح في تسجيل الدخول",
      loginerror:"خطأ في تسجيل الدخول",
      Max: '‫نايكي ايير ماكس ۲۰۱۸‬‎ ',
      pricemax: '۱۸۰۰,۰۰',
      Formal: 'لجميع المناسبات الرسمية',
      Outfit: 'مجموعة ملابس جديدة',
      occasion: 'لأنه يمكنك الاختيار بين الملابس المختلفة والأنماط المناسبة الخاصة بك وأيضا محاولة العثور على حجم مناسب لك',
      Formal: 'لجميع المناسبات الرسمية',
      moore: ' اكتشف المزيد ...',
      Outfit: 'مجموعة ملابس جديدة',
      occasion: 'لأنه يمكنك الاختيار بين الملابس المختلفة والأنماط المناسبة الخاصة بك وأيضا محاولة العثور على حجم مناسب لك',
      moore: 'اكتشف المزيد ...',
      Sale: ' اخر عروض الصيف',
      Extra: 'عرض خصم ٥۰% على اي منتج',
      Outfitss: 'التالي',
      Discover: ' اكتشف المزيد... ',
      wish: '٥۰۰',
      namehere: 'ضع اسمك هنا',
      bestSellingProd:'أكثر منتجات مبيعاً',
      fsale: '۲۰۰.۰۰۰',
      come: '۲۰۰.۰۰۰',
      event: 'دعوة',
      egyfash: 'مهرجان مصر للموضة ۲۰۱۸ ',
      date: '۲۸ سبتمبر لعام ۲۰۱۸ ',
      poppro: 'منتجات مشهورة ',
      saleext: ' ٥۰% اضافية على كل شيئ',
      outfits: 'الجديد',
      dismore: 'اكتشف الجديد',
      wish: '۲۰۰',
      fitname: 'ضع اسمك هنا',
      priceprod: '۲۰۰.۰۰۰ جنيه',
      wish: '۲۰۰',
      shipping: 'الشحن',
      billing: 'الفاتورة',
      retypeMsg:'يرجى كتابة كلمة المرور',
      matcherror:'كلمة المرور غير مطابقة',
      complete:"اكتمال",
      refunded:'أعاد مالا',
      shippingAndBillingInfo:'معلومات الشحن والفاتورة',
      fill:'قم بإملاء الخانات التالية',
      orders: 'الطلبات الاكثر من ۱۰۰۰ جنيه',
      return: '۳۰ يوم عودة',
      proplem: 'إذا البضائع لديها مشكلة',
      payment: 'دفع امن',
      secure: 'دفع امن ۱۰۰%',
      support: 'دعم ۲٤ ساعة',
      Dedicated: 'دعم مخصص',
      Subscribe: 'لا تفوت أي شيء! الاشتراك',
      informed: 'أود أن أكون على علم بالاتجاهات والعروض الحالي قسائم عن طريق البريد الإلكتروني في المستقبل. يمكن إلغاء التسجيل في أي وقت مجانا.',
      TShirts: 'تيشيرت',
      Shirts: "قميص",
      Shoes: 'احذية',
      Accessorie: 'منتجات',
      dimensions:'مقاسات',
      newarr: 'قادم جديد',
      popular: ' الملابس المشهورة',
      Trending: 'المنتجات المنتشرة',
      Tbrands: 'البراندات المتداولة',
      Bestie: 'افضل المنتجات',
      duct: 'منتج',
      catee: 'الاقسام',
      acc: ' الايميل الخاص بي',
      prof: ' الصفحة الخاصة بي',
      order: 'الطلبات الخاصه بي',
      wishhy: 'قائمة امنياتي',
      paymentfot: 'المدفوعات الخاصة بي',
      addr: 'العنوان',
      district: ' ناصر سيتي , مصر ۹ شارع حافظ رمضان وشارع احمد فخري الحي السادس',
      call: 'اتصل بنا : (+۲) ۱۲۳-٥٧-۸۹٦ ',
      copyright: 'دولابي. -كل الحقوق محفوظه 2018@',
      wom: 'السيدات',
      sortby: 'ترتيب حسب : ',
      elsehere: 'شيء آخر هنا',
      Separated: 'رابط منفصل',
      elsehere: 'شيء آخر هنا',
      Separated: 'رابط منفصل',
      itempage: 'عرض: ',
      Filtercat: ' فئة التصفيه',
      mencategory: 'فئة الرجال',
      womencategory: 'فئة السيدات',
      kidscategory: 'فئة الاطفال',
      shopcategory: 'فئه التسوق',
      size: ' المقاس',
      smallsize: 'مقاس صغير جدا',
      medsize: 'مقاس صغير',
      ssize: 'مقاس اخر',
      large: 'مقاس كبير',
      pstyle: 'استايل المنتج',
      clsstyle: 'استايل كلاسيكي',
      cagstyle: 'استايل كاجوال',
      bigstyle: 'استايل كبير',
      flatstyle: 'ستايل فلات',
      advstyle: 'نمط المغامرة',
      fet: ' المميزات',
      egy: 'صنع في مصر',
      ek: 'صنع في امريكا',
      brandss: 'البراندات',
      search: 'قم بالبحث عن البراند',
      calvin: 'كالفين كلاين',
      zara: 'زارا',
      polo: 'بولو رالف رولين ',
      procolor: 'لون المنتج',
      prored: 'احمر',
      toprates: 'اعلي تقييم',
      fife: '٥ نجوم',
      four: '٥ نجوم',
      three: '٥ نجوم',
      community:"انضم إلى مجتمعنا",
      topproduct: 'أعلى تصنيف المنتجات',
      shirtctn: 'قميص كاجوال قطن جديد ام ۲۰۱۸ ربيع',
      priceee: '۱٧۸۰۰.۰۰ جنيه ',
      fpro: 'منتجات مميزة',
      noProdWish:'لا توجد منتجات متوفرة في قائمة مفضلاتك',
      salee: 'خصم ۲٥%',
      corporate: 'قميص رسمي للشركات روبية',
      rev: '(۱۳۰ مراجعه)',
      was: '۱۳۰.۰۰ جنيه',
      new: '۱۳۰.۰۰ جنيه',
      cartt: 'اضف هنا',
      discount: 'خصم ۲٥%',
      corporate: 'قميص رسمي للشركات روبية',
      rev: '(۱۳۰ مراجعه)',
      was: '۱۳۰.۰۰ جنيه',
      new: '۱۳۰.۰۰ جنيه',
      lorem: 'ولكن حتى يتم ماكياج مجانا. كرة القدم كرة القدم الذي تخرج لتوه حاملا دائما. ليس هناك منطقة ولحم البقر المقررات الجامعية لكرة القدم، تعيين إلى صفر.',
      cartt: 'اضف هنا',
      vious: 'سابق',
      next: 'التالي',
      log: 'دخول',
      get: 'ادخل واكتشف ملابسنا',
      rem: 'تذكرني',
      pass: 'فقدت كلمة المرور الخاصة بك',
      agree: ' عن طريق تسجيل الدخول فإنك توافق على موقعنا ',
      terms: 'البنود و الظروف',
      us: ' من الاستخدام',
      community: ' انضم إلى مجتمعنا',
      reg: 'تسجيل',
      loreem: 'لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبورأنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد       أكسير سيتاشن يللأمكو لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات . ديوا',
      creat: ' انشاء حساب',
      mail: 'ادخل برديدك الالكتروني هنا',
      sign: 'سجل الان',
      userinfo: ' ملعومات العضو',
      shipadd: 'عنوان الشحن',
      order: 'أوامر التاريخ',
      paymet: 'طرق الدفع',
      revv: 'مراجعات & تقييم',
      basiinfo: 'معلومات اساسية',
      clicuplod: 'اضغط لتحميل صورتك',
      fulname: 'الاسم',
      emil: 'الايميل',
      gender: 'النوع',
      male: 'ذكر',
      female: 'امرأه',
      other: 'غير ذلك',
      mahmod: 'محمود عبد العزيز',
      birth: 'يوم الميلاد',
      dateselec: 'اضغط هنا لتحديد التاريخ',
      male: 'ذكر',
      country: 'البلد :',
      state: 'الولايه :',
      postal: 'الرمز البريدي :',
      items:'العناصر',
      phone: 'رقم الهاتف',
      additionalPhone:'رقم هاتف إضافي',
      same:'الفاتورة لنفس العنوان',
      orderTotal:'إجمالي الطلب',
      orderNumber:"رقم الطلب",
      placeOrder:'اطلب الان',
      social: 'المعلومات الاجتماعية',
      //  fb:'الفيسبوك :',
      //  twitt:'تويتر :',
      //  yout:'اليوتيوب :',
      //  insta:'الانستجرام :',
      upprof: 'تحديث الملف',
      home: 'الصفحة الرئيسية',
      shopp: 'كارت التسوق',
      shopping:'التسوق',
      shippingAndPaymentInfo:'معلومات الشحن و الدفع',
      confirmation:'التأكيد',
      prod: 'منتج',
      price: ' السعر',
      quantity: 'الكمية',
      totalpric: 'السعر الكلي',
      action: 'عمل',
      teeshirt: 'تي شيرت قصير الأكمام للرجال ۲ اكس لارج قطن كاريبيان ك۳٥٦ ۲ اكس لارج قطن كاريبيان ك۳٥٦',
      menshirts: 'رجال - قمصان',
      blue: ' ازرق',
      categ: 'الفئة :',
      colorr: 'اللون :',
      sizee: ' الحجم :',
      salary: '۱۸۰ جنيه',
      teeshirt: 'تي شيرت قصير الأكمام للرجال ۲ اكس لارج قطن كاريبيان ك۳٥٦ ۲ اكس لارج قطن كاريبيان ك۳٥٦',
      menshirts: 'رجال - قمصان',
      blue: ' ازرق',
      calcu: 'حساب الشحن',
      action: 'عمل',
      anotaction: 'رد فعل اخر',
      someelse: 'اي شيئ اخر هنا',
      separated: 'رابط منفصل',
      someelse: 'اي شيئ اخر هنا',
      separated: 'رابط منفصل',
      city: 'مدينة *',
      country: 'بلد *',
      update: 'تحديث',
      coupon: ' كود القسيمة',
      loreem: 'لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبورأنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد ',
      codee: 'اضف الرمز هنا',
      app: '  تتطبيق',
      sub: ' كارت المجموع-الفرعي :',
      subtotal:'المجموع الفرعي:',
      cartt: ' مجموع الكارت :',
      salary: '۱۸۰ جنيه',
      handle: 'شحن وتسليم : ',
      free: 'مجانا',
      salary: '۱۸۰ جنيه',
      total: ' مجموع الكارت :',
      checkout:'الدفع',
      itemtitle: '• فئة الرجال •',
      method: ' اضافة طريقة دفع',
      cridt: ' بطاقة ائتمان ',
      pypl: 'باي بال',
      cash: 'الدفع عند الوصول',
      action: 'عمل',
      anotaction: 'رد فعل اخر',
      someelse: 'اي شيئ اخر هنا',
      separated: 'رابط منفصل',
      conttwo: 'تبويب ۲ المحتوى',
      contthre: 'تبويب ۳ المحتوى',
      addpaymen: 'اضافة طريقة دفع',
      process: 'الغاء العملية',
      exyear: 'سنة الالغاء',
      exmonth: 'شهر الانتهاء',
      ecom: ' شروط وأحكام التجارة الإلكترونية',
      loreem: 'لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبورأنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد ديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمب أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد   أكسير سيتاشن يللأمكو لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات . ديواس  أيوتي أريري دولار إن ريبريهينديرأيت فوليوبتاتي فيلايت أيسسي كايلليوم دولار أيو فيجايت  نيولا باراياتيور. أيكسسيبتيور ساينت أوككايكات كيوبايداتات نون بروايدينت ,سيونت ان كيولبا  كيو أوفيسيا ديسيريونتموليت انيم أيدي ايست لابوريوم ',
      number: '  قائمة مرقمة',
      consectetur: ' لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت',
      eiusmod: 'الحسومات، لكنها تفعل ، لكنها تفعل ',
      tempor: 'ذلك أن العمل من فكرة عظيمة، ومنذ فترة طويلة وحيوية،',
      mark: 'قائمة محدّدة',
      table: 'الطاولة',
      popitem: 'العناصر المشهورة',
      size: 'الحجم',
      color: 'اللون',
      drinks: ' واحد ، هناك المشروبات التي تجعلك يتقلص',
      inche: ' ۱٦ انش ',
      color: 'اسود',
      grow: 'ثانيا ، هناك أطعمة تجعلك تنمو.',
      inche: ' ۱٦ انش ',
      color: 'اسود',
      grow: 'ثانيا ، هناك أطعمة تجعلك تنمو.',
      inche: ' ۱٦ انش ',
      color: 'اسود',
      grow: 'ثانيا ، هناك أطعمة تجعلك تنمو.',
      inche: ' ۱٦ انش ',
      color: 'اسود',
      text: ' النص & اقتباس ',
      loreim: 'لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور    أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد    أكسير سيتاشن يللأمكو لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات  ',
      emone: 'عاطل عن العمل، ولكن بالنسبة ',
      emtwo: 'المنتجات الراحة. ',
      loreimm: 'لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد أكسير سيتاشن يللأمكو لابورأس نيسي يت أليكيوب أكس',
      loreim: 'لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور    أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد    أكسير سيتاشن يللأمكو لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات . ديوا    أيوتي أريري دولار إن ريبريهينديرأيت فوليوبتاتي فيلايت أيسسي كايلليوم دولار أيو فيجاي   نيولا باراياتيور. أيكسسيبتيور ساينت أوككايكات كيوبايداتات نون بروايدينت ',
      emone: 'عاطل عن العمل، ولكن بالنسبة ',
      emtwo: 'سيونت ان كيولبا   كيو أوفيسيا ديسيريونتموليت انيم أيدي ايست لابوريوم ',
      itemtitle: '• فئة الرجال •',
      availableColours: "الألوان المتاحة",
      availableSizes: "الأحجام المتوفرة",
      productQuantity: "كمية المنتج",
      nocolor: 'لا توجد الوان متاحة',
      addcart: 'اضف الى العربة',
      producttype: 'نوع المنتج :',
      addshipping: ' إضافة معلومات عنوان الشحن',
      location: 'خريطة الموقع :',
      firstname: 'الاسم الاول* :',
      lastname: 'الاسم الاخير* :',
      email: 'الايميل  * :',
      addressOne: 'العنوان 1 * :',
      addressTwo: 'العنوان 2 :',
      ipsum: 'الابجد هوز ,',
      town: ' مدينة * :',
      mobile: 'الموبايل * :',
      note: 'الملاحظات * :',
      country: ' البلد * :',
      addadress: 'اضف العنوان',
      cancel: 'الغاء العملية',
      emptyCart: "عربة التسوق فارغة.",
      Search: "ابحث",
      password:"كلمة السر",
     retypePassword:"أعد إدخال كلمة السر ",
     NewPassword:"كلمة السر الجديدة     ",
     AtoZ:"من الألف إلى الياء",
     ZtoA:"من الياء إلى الألف",
     LowtoHigh:"الأقل سعراً",
     HightoLow:"الأعلى سعراً",
     noTypes:'لا توجد أنواع متاحة لهذه الفئة',
     logout:'الخروج',
     loginReg:'دخول',
     afterRegister:".بعد التسجيل ، ستتلقى رسالة إلكترونية تحتوي على رمز التحقق لإثبات ملكية حسابك ",
     itempage1:' ١٢ صفحة من العناصر',
     itempage2:' ٢٤ صفحة من العناصر',
     itempage3:' ٤٨ صفحة من العناصر',
     orderDate:'تاريخ الطلب',
     totalCost:'التكلفة الإجمالية',
     orderDetails:'تفاصيل طلبك',
     customerDetails:'تفاصيل العميل',
     details:"تفاصيل",
     biladd:'عنوان الفواتير',
     backtoshopping:'العودة إلى التسوق',
     reviewedOrder:'سوف تحصل على استعراض وشحنه في أقرب وقت ممكن',
     thankyou:'شكرا جزيلا!',
     recieveMsg:'تم استلام طلبك ',
     detailsMsg:'تفاصيل طلبك ',
     print:'طباعة'
     
     
     







    }
};


// WEBPACK FOOTER //
// ./src/lang.js